
<mat-card class="card-user-claim-form mat-elevation-z8">
    <mat-card-subtitle>Delete Project</mat-card-subtitle>
    <mat-card-content>

        <form [formGroup]="projectForm" novalidate>

            <mat-form-field class="form-element" appearance="none">
                <input matInput hidden  formControlName="id" readonly>
            </mat-form-field>

            <mat-form-field class="form-element">
                <input matInput  formControlName="name" readonly>
            </mat-form-field>

            <mat-form-field class="form-element">
                <input matInput formControlName="url" readonly>
            </mat-form-field>   
        </form>
        <mat-action-row>
            <button mat-button (click)="deleteProject()" color="primary">Delete Project</button>
        </mat-action-row>
    </mat-card-content>
</mat-card>